import { rutinInfos } from '../../_Common/Const/RutinInfo';
import getStandardRutin from '../../_Common/Utils/getStandardRutin';
const ARRutiner = {
  rtnTillgang: {
    component: getStandardRutin(rutinInfos.rtnTillgang, 'ARTillgang'),
  },
  rtnVisaInvestering: {
    component: getStandardRutin(rutinInfos.rtnVisaInvestering, 'ARUpprakning'),
  },
};

export default ARRutiner;
